import React from 'react';
import './switch.css'
import { Tooltip } from '@mui/material';

function SimpleSwitch(props) {

    const toggleSwitch = (e) => {
        if (props.onChange) {
            props.onChange(e)
        }

    }
    return (
        <label className="switch">
            <Tooltip title={props.tooltip ? "you cannot enable Redial if Pause after disposition is true" : ""} >
                <div>
                    <input type="checkbox"
                        disabled={props.disabled || false}
                        onChange={toggleSwitch}
                        checked={props.checked || false}
                        id={props.id || null}
                    >
                    </input>
                    <span className="slider round"></span>
                </div>
            </Tooltip>
        </label>
    )
}

export default SimpleSwitch